import { z } from "zod"

export const layerTypeSchema = z.enum(["ortho", "infrared"])
export const processingModeSchema = z.enum(["iterative", "oneShot", "oneShotWithPreview"])

export const layerConfigSchema = z.object({
    layerId: z.string(),
    orgId: z.string(),
    projectId: z.string(),
    layerType: layerTypeSchema,
    createdBy: z.string(),
    createdAt: z.number(),
    processingMode: processingModeSchema,
    imageCount: z.number().positive().optional(),
})

export const creatableLayerConfigSchema = layerConfigSchema

export type LayerConfig = z.infer<typeof layerConfigSchema>
export type CreatableLayerConfig = z.infer<typeof creatableLayerConfigSchema>
